/**
 * permissions.js — Centralized role-based permissions (07/07/2026)
 *
 * Punto UNICO di verità per i permessi condizionati dal ruolo operatore.
 * Nessun check `role === "amministratore"` sparso nei componenti figli:
 * ogni feature guardata da un permesso importa un helper da qui.
 *
 * Design:
 *  - Helper puri (input: role string, output: boolean).
 *  - Nessuna dipendenza da React → utilizzabili anche fuori render.
 *  - Estendibili senza rompere il contratto: aggiungere nuove costanti
 *    e nuovi helper, mai modificare la semantica di quelli esistenti.
 *
 * Roadmap: quando nuovi dashboard/KPI/analytics arriveranno, riusare
 * `canViewFinancialDashboard` — NON introdurre check di ruolo inline.
 */

/**
 * Ruoli che hanno visione manageriale sull'attività (dashboard
 * finanziarie, marginalità, cash flow, ecc.).
 */
export const ADMIN_ROLES = Object.freeze(["amministratore", "responsabile"]);

/**
 * True se il ruolo è ammesso ai riepiloghi finanziari (KPI economici,
 * totali, saldi, breakdown pagamenti).
 *
 * Ruoli autorizzati:
 *  - amministratore  → TRUE
 *  - responsabile    → TRUE
 *  - operatore_studio  → FALSE
 *  - operatore_agenzia → FALSE
 *  - qualsiasi altro / undefined → FALSE (fail-closed)
 *
 * Da usare in ogni pannello che espone "quanto stiamo incassando /
 * quanto abbiamo fatturato / saldo di periodo / marginalità". NON
 * usare per gate di funzioni operative (create/edit/delete) — quelli
 * hanno le loro permission dedicate.
 */
export function canViewFinancialDashboard(operatorRole) {
  return ADMIN_ROLES.includes((operatorRole || "").toString());
}
